import Assistant from './view/desktop/Assistant';
import AssistantButton from './view/desktop/components/AssistantButton';

export { AssistantButton };
export default Assistant;
